import React, { useState, useEffect } from 'react';
import { registerLandlord, requestRegistrationOTP } from '../services/api';

const NAVY = '#1f4e79';
const ORANGE = '#f26522';

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&family=Inter:wght@400;500;600&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  body { font-family: 'Inter', sans-serif; -webkit-font-smoothing: antialiased; }

  .reg-root {
    min-height: 100vh;
    display: grid;
    grid-template-columns: 1fr 1fr;
  }

  /* ── LEFT PANEL ── */
  .reg-left {
    background: linear-gradient(160deg, ${NAVY} 0%, #0d2d52 60%, #07152a 100%);
    display: flex; flex-direction: column;
    justify-content: space-between;
    padding: 32px 52px;
    position: relative; overflow: hidden;
  }
  .reg-left::before {
    content: '';
    position: absolute; top: -150px; right: -150px;
    width: 500px; height: 500px; border-radius: 50%;
    background: radial-gradient(circle, rgba(242,101,34,0.15) 0%, transparent 65%);
    pointer-events: none;
  }
  .reg-left::after {
    content: '';
    position: absolute; bottom: -150px; left: -100px;
    width: 400px; height: 400px; border-radius: 50%;
    background: radial-gradient(circle, rgba(255,255,255,0.04) 0%, transparent 65%);
    pointer-events: none;
  }
  .reg-logo { position: relative; z-index: 1; }
  .reg-logo img { height: 150px; width: auto; object-fit: contain; margin-bottom: -20px; filter: None !important; }
  .reg-content { position: relative; z-index: 1; }
  .reg-tag {
    display: inline-flex; align-items: center; gap: 8px;
    background: rgba(242,101,34,0.15);
    border: 1px solid rgba(242,101,34,0.25);
    padding: 6px 14px; border-radius: 20px; margin-bottom: 28px;
  }
  .reg-tag-dot {
    width: 7px; height: 7px; border-radius: 50%;
    background: ${ORANGE}; animation: glow 2s infinite;
  }
  @keyframes glow {
    0%,100% { box-shadow: 0 0 0 2px rgba(242,101,34,0.2); }
    50% { box-shadow: 0 0 0 5px rgba(242,101,34,0.1); }
  }
  .reg-tag-text { font-size: 12px; font-weight: 600; color: ${ORANGE}; letter-spacing: 0.5px; }
  .reg-h2 {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 36px; font-weight: 800; color: #fff;
    line-height: 1.15; letter-spacing: -1px; margin-bottom: 16px;
  }
  .reg-h2 span { color: ${ORANGE}; }
  .reg-sub {
    font-size: 15px; color: rgba(255,255,255,0.55);
    line-height: 1.75; margin-bottom: 36px; max-width: 340px;
  }
  .reg-steps { display: flex; flex-direction: column; gap: 16px; }
  .reg-step {
    display: flex; align-items: flex-start; gap: 14px;
  }
  .reg-step-num {
    width: 28px; height: 28px; border-radius: 50%; flex-shrink: 0;
    background: rgba(242,101,34,0.20);
    display: flex; align-items: center; justify-content: center;
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 13px; font-weight: 700; color: ${ORANGE};
  }
  .reg-step-text { font-size: 14px; color: rgba(255,255,255,0.65); line-height: 1.5; padding-top: 4px; }
  .reg-step-text strong { color: #fff; font-weight: 600; }
  .reg-footer { position: relative; z-index: 1; font-size: 12px; color: rgba(255,255,255,0.25); }

  /* ── RIGHT PANEL ── */
  .reg-right {
    background: #f8fafc;
    display: flex; align-items: center; justify-content: center;
    padding: 48px 40px; overflow-y: auto;
  }
  .reg-card {
    background: #fff;
    border: 1px solid rgba(31,78,121,0.10);
    border-radius: 24px;
    padding: 44px 40px;
    width: 100%; max-width: 420px;
    box-shadow: 0 8px 48px rgba(31,78,121,0.10), 0 1px 3px rgba(0,0,0,0.04);
  }

  /* Step indicator */
  .step-bar {
    display: flex; align-items: center; gap: 0;
    margin-bottom: 32px;
  }
  .step-item {
    display: flex; align-items: center; gap: 8px; flex: 1;
  }
  .step-circle {
    width: 28px; height: 28px; border-radius: 50%; flex-shrink: 0;
    display: flex; align-items: center; justify-content: center;
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 12px; font-weight: 700;
    transition: all 0.3s;
  }
  .step-circle.active { background: ${ORANGE}; color: #fff; }
  .step-circle.done { background: #22c55e; color: #fff; }
  .step-circle.idle { background: #e2e8f0; color: #94a3b8; }
  .step-label-text { font-size: 12px; color: #94a3b8; white-space: nowrap; }
  .step-label-text.active { color: ${NAVY}; font-weight: 600; }
  .step-connector { flex: 1; height: 1px; background: #e2e8f0; margin: 0 8px; }

  .card-title {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 22px; font-weight: 800; color: #0f172a;
    margin-bottom: 6px; letter-spacing: -0.5px;
  }
  .card-sub { font-size: 14px; color: #64748b; line-height: 1.6; margin-bottom: 28px; }

  /* Form */
  .field-wrap { margin-bottom: 18px; }
  .field-label {
    display: block; font-size: 13px; font-weight: 600;
    color: #374151; margin-bottom: 7px;
  }
  .field-label span { color: #94a3b8; font-weight: 400; font-size: 12px; }
  .text-input {
    width: 100%; padding: 13px 16px;
    border: 1.5px solid #e2e8f0; border-radius: 12px;
    font-family: 'Inter', sans-serif; font-size: 14px; color: #0f172a;
    background: #f8fafc; outline: none; transition: all 0.2s;
  }
  .text-input:focus {
    border-color: ${ORANGE}; background: #fff;
    box-shadow: 0 0 0 3px rgba(242,101,34,0.10);
  }
  .text-input::placeholder { color: #94a3b8; }
  .phone-wrap { position: relative; }
  .phone-prefix {
    position: absolute; left: 14px; top: 50%; transform: translateY(-50%);
    font-size: 14px; font-weight: 600; color: ${NAVY};
    display: flex; align-items: center; gap: 6px; pointer-events: none;
  }
  .phone-divider { width: 1px; height: 18px; background: #e2e8f0; }
  .phone-input { padding-left: 80px; }
  .referral-wrap { position: relative; }
  .referral-input {
    letter-spacing: 3px; font-weight: 600; text-transform: uppercase;
  }
  .referral-locked {
    background: #f0fdf4 !important; color: #166534 !important;
    border-color: #86efac !important;
  }
  .referral-badge {
    position: absolute; right: 14px; top: 50%; transform: translateY(-50%);
    font-size: 11px; font-weight: 700; color: #16a34a;
    background: #dcfce7; padding: 2px 8px; border-radius: 10px;
  }
  .referral-hint {
    font-size: 12px; color: #94a3b8; margin-top: 6px; line-height: 1.5;
  }

  /* OTP */
  .otp-hint {
    display: flex; align-items: center; gap: 10px;
    background: #f0fdf4; border: 1px solid #bbf7d0;
    border-radius: 12px; padding: 12px 16px; margin-bottom: 20px;
  }
  .otp-hint-icon { font-size: 20px; flex-shrink: 0; }
  .otp-hint-text { font-size: 13px; color: #166534; line-height: 1.5; }
  .otp-input {
    text-align: center; font-size: 28px; font-weight: 700;
    letter-spacing: 12px; color: ${NAVY};
    font-family: 'Plus Jakarta Sans', sans-serif;
  }

  /* Buttons */
  .btn-primary {
    width: 100%; padding: 15px;
    background: linear-gradient(135deg, ${ORANGE}, #e05a1a);
    color: #fff; border: none; cursor: pointer;
    border-radius: 12px; font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 15px; font-weight: 700;
    transition: all 0.25s cubic-bezier(0.4,0,0.2,1);
    box-shadow: 0 4px 16px rgba(242,101,34,0.30);
    margin-bottom: 12px;
  }
  .btn-primary:hover:not(:disabled) { transform: translateY(-2px); box-shadow: 0 8px 24px rgba(242,101,34,0.40); }
  .btn-primary:disabled { background: #cbd5e1; box-shadow: none; cursor: not-allowed; }
  .btn-ghost {
    width: 100%; padding: 10px;
    background: none; border: none;
    color: #64748b; font-size: 13px; cursor: pointer;
    transition: color 0.2s; font-family: 'Inter', sans-serif; text-align: center;
  }
  .btn-ghost:hover { color: ${NAVY}; }
  .login-link {
    background: none; border: none; cursor: pointer;
    color: ${ORANGE}; font-size: 13px; font-weight: 700;
    padding: 0; transition: color 0.2s;
  }
  .login-link:hover { color: #e05a1a; }
  .divider { border: none; border-top: 1px solid #f1f5f9; margin: 16px 0; }
  .login-row { text-align: center; font-size: 13px; color: #64748b; }

  /* Error */
  .error-box {
    background: #fef2f2; border: 1px solid #fecaca;
    border-radius: 10px; padding: 12px 16px;
    color: #dc2626; font-size: 13px; text-align: center;
    margin-top: 12px; line-height: 1.5;
  }

  /* Responsive */
  @media (max-width: 768px) {
    .reg-root { grid-template-columns: 1fr; }
    .reg-left { display: none; }
    .reg-right { padding: 24px 20px; background: linear-gradient(160deg, ${NAVY} 0%, #0d2d52 100%); }
    .reg-card { border-radius: 20px; padding: 32px 24px; }
  }
`;

export default function Register({ onRegister, onBack }) {
  const [step, setStep] = useState('details');
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [referralCode, setReferralCode] = useState('');
  const [referralLocked, setReferralLocked] = useState(false);
  const [otp, setOtp] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [tosAccepted, setTosAccepted] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get('ref');
    if (ref) {
      setReferralCode(ref.trim().toUpperCase());
      setReferralLocked(true);
    }
  }, []);

  const handleSubmitDetails = async () => {
    if (!name.trim()) { setError('Please enter your full name'); return; }
    if (phone.length !== 10) { setError('Enter a valid 10-digit phone number'); return; }
    if (!referralCode.trim()) { setError('A referral code is required. Please ask an existing Hashvi landlord for their code.'); return; }
    if (!tosAccepted) { setError('Please accept the Terms of Service and Privacy Policy to continue.'); return; }
    setLoading(true); setError('');
    try {
      await requestRegistrationOTP(phone);
      setStep('otp');
    } catch (err) {
      setError(err.response?.data?.detail || 'Failed to send OTP');
    } finally { setLoading(false); }
  };

  const handleVerifyOTP = async () => {
    if (otp.length !== 6) { setError('Enter the 6-digit OTP'); return; }
    setLoading(true); setError('');
    try {
      const res = await registerLandlord({
        name: name.trim(), phone,
        email: email.trim() || null,
        referral_code: referralCode.trim().toUpperCase(),
        otp
      });
      onRegister(
        { name: res.data.landlord_name, id: res.data.landlord_id, referral_code: res.data.referral_code || '' },
        res.data.access_token
      );
    } catch (err) {
      setError(err.response?.data?.detail || 'Registration failed');
    } finally { setLoading(false); }
  };

  return (
    <>
      <style>{styles}</style>
      <div className="reg-root">

        {/* ── LEFT PANEL ── */}
        <div className="reg-left">
          <div className="reg-logo">
            <img src="/Hashvi_logo_white_no_BG.svg" alt="Hashvi Rental" />
          </div>

          <div className="reg-content">
            <div className="reg-tag">
              <span className="reg-tag-dot" />
              <span className="reg-tag-text">Early Access · Bangalore</span>
            </div>
            <h2 className="reg-h2">
              Join landlords who<br />
              <span>collect rent automatically.</span>
            </h2>
            <p className="reg-sub">
              Set up in under 5 minutes. Your tenants don't need to install anything. Receipts generated and sent automatically.
            </p>
            <div className="reg-steps">
              {[
                { n: '1', t: 'Fill your details', d: 'Name, phone and referral code' },
                { n: '2', t: 'Verify on WhatsApp', d: 'Quick OTP to confirm your number' },
                { n: '3', t: 'Start managing', d: 'Add properties and onboard tenants' },
              ].map((s, i) => (
                <div className="reg-step" key={i}>
                  <span className="reg-step-num">{s.n}</span>
                  <span className="reg-step-text"><strong>{s.t}</strong> — {s.d}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="reg-footer">
            © 2026 Hashvi Ventures Private Limited · Bangalore
          </div>
        </div>

        {/* ── RIGHT PANEL ── */}
        <div className="reg-right">
          <div className="reg-card">

            {/* Step bar */}
            <div className="step-bar">
              <div className="step-item">
                <div className={`step-circle ${step === 'details' ? 'active' : 'done'}`}>
                  {step === 'otp' ? '✓' : '1'}
                </div>
                <span className={`step-label-text ${step === 'details' ? 'active' : ''}`}>Details</span>
              </div>
              <div className="step-connector" />
              <div className="step-item">
                <div className={`step-circle ${step === 'otp' ? 'active' : 'idle'}`}>2</div>
                <span className={`step-label-text ${step === 'otp' ? 'active' : ''}`}>Verify OTP</span>
              </div>
            </div>

            {step === 'details' ? (
              <>
                <div className="card-title">Create your account 🏠</div>
                <div className="card-sub">Fill in your details to get started with Hashvi Rental.</div>

                {/* Name */}
                <div className="field-wrap">
                  <label className="field-label">Full Name</label>
                  <input
                    className="text-input"
                    type="text"
                    placeholder="As it should appear on receipts"
                    value={name}
                    onChange={e => setName(e.target.value)}
                  />
                </div>

                {/* Phone */}
                <div className="field-wrap">
                  <label className="field-label">WhatsApp Number</label>
                  <div className="phone-wrap">
                    <span className="phone-prefix">🇮🇳 +91 <span className="phone-divider" /></span>
                    <input
                      className="text-input phone-input"
                      type="tel"
                      placeholder="10-digit number"
                      value={phone}
                      maxLength={10}
                      onChange={e => setPhone(e.target.value.replace(/\D/g, '').slice(0, 10))}
                    />
                  </div>
                </div>

                {/* Email */}
                <div className="field-wrap">
                  <label className="field-label">Email <span>(optional)</span></label>
                  <input
                    className="text-input"
                    type="email"
                    placeholder="For account records"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                  />
                </div>

                {/* Referral Code */}
                <div className="field-wrap">
                  <label className="field-label">Referral Code</label>
                  <div className="referral-wrap">
                    <input
                      className={`text-input referral-input ${referralLocked ? 'referral-locked' : ''}`}
                      type="text"
                      placeholder="e.g. HVRI-X7K2"
                      value={referralCode}
                      onChange={e => !referralLocked && setReferralCode(e.target.value.toUpperCase())}
                      readOnly={referralLocked}
                    />
                    {referralLocked && <span className="referral-badge">✓ Applied</span>}
                  </div>
                  {!referralLocked && (
                    <p className="referral-hint">Ask an existing Hashvi landlord for their referral code.</p>
                  )}
                </div>

                {/* ── TERMS OF SERVICE CHECKBOX ── */}
                <div style={{
                  display: 'flex', alignItems: 'flex-start', gap: 10,
                  background: tosAccepted ? 'rgba(34,197,94,0.06)' : '#f8fafc',
                  border: tosAccepted ? '1.5px solid rgba(34,197,94,0.30)' : '1.5px solid #e2e8f0',
                  borderRadius: 10, padding: '12px 14px', marginBottom: 16,
                  cursor: 'pointer', transition: 'all 0.2s'
                }} onClick={() => setTosAccepted(!tosAccepted)}>
                  <div style={{
                    width: 18, height: 18, borderRadius: 4, flexShrink: 0, marginTop: 2,
                    background: tosAccepted ? '#16a34a' : '#fff',
                    border: tosAccepted ? '2px solid #16a34a' : '2px solid #cbd5e1',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    transition: 'all 0.2s'
                  }}>
                    {tosAccepted && <span style={{ color: '#fff', fontSize: 11, fontWeight: 700 }}>✓</span>}
                  </div>
                  <p style={{ fontSize: 12, color: '#374151', lineHeight: 1.6, userSelect: 'none' }}>
                    I agree to the{' '}
                    <a href="/privacy-policy" target="_blank" rel="noreferrer"
                      style={{ color: '#f26522', fontWeight: 600, textDecoration: 'none' }}
                      onClick={e => e.stopPropagation()}>
                      Terms of Service &amp; Privacy Policy
                    </a>
                    . I confirm I will not upload Aadhaar card images and will only upload permitted government-issued ID documents (Voter ID, Passport or Driving License).
                  </p>
                </div>

                <button
                  className="btn-primary"
                  onClick={handleSubmitDetails}
                  disabled={loading || !tosAccepted}
                >
                  {loading ? 'Sending OTP...' : 'Continue — Verify on WhatsApp →'}
                </button>

                <hr className="divider" />
                <div className="login-row">
                  Already have an account?{' '}
                  <button className="login-link" onClick={onBack}>Login here</button>
                </div>
              </>
            ) : (
              <>
                <div className="card-title">Check WhatsApp 📱</div>
                <div className="card-sub">Enter the 6-digit OTP sent to your WhatsApp to complete registration.</div>

                <div className="otp-hint">
                  <span className="otp-hint-icon">💬</span>
                  <span className="otp-hint-text">
                    OTP sent to <strong>+91 {phone}</strong> on WhatsApp. Check your messages.
                  </span>
                </div>

                <div className="field-wrap">
                  <label className="field-label">6-Digit OTP</label>
                  <input
                    className="text-input otp-input"
                    type="number"
                    placeholder="——————"
                    value={otp}
                    onChange={e => setOtp(e.target.value.slice(0, 6))}
                    onKeyDown={e => e.key === 'Enter' && handleVerifyOTP()}
                  />
                </div>

                <button
                  className="btn-primary"
                  onClick={handleVerifyOTP}
                  disabled={loading || otp.length < 6}
                >
                  {loading ? 'Verifying...' : 'Verify & Enter Hashvi →'}
                </button>

                <button
                  className="btn-ghost"
                  onClick={() => { setStep('details'); setError(''); setOtp(''); }}
                >
                  ← Back to details
                </button>
              </>
            )}

            {error && <div className="error-box">⚠️ {error}</div>}
          </div>
        </div>
      </div>
    </>
  );
}
